"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = tslib_1.__importDefault(require("react"));
const prop_types_1 = tslib_1.__importDefault(require("prop-types"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const Caret_1 = tslib_1.__importDefault(require("./Caret"));
const SplitCaretButton = react_1.default.forwardRef((_a, ref) => {
    var { disabled, bsStyle, className } = _a, remainingProps = tslib_1.__rest(_a, ["disabled", "bsStyle", "className"]);
    const splitCaretButtonClasses = (0, classnames_1.default)('dropdown-toggle', 'btn', `btn-${bsStyle}`, disabled && 'disabled', className);
    return ((0, jsx_runtime_1.jsx)("button", Object.assign({}, remainingProps, { role: 'button', type: 'button', className: splitCaretButtonClasses, ref: ref }, { children: (0, jsx_runtime_1.jsx)(Caret_1.default, {}) })));
});
exports.default = SplitCaretButton;
SplitCaretButton.propTypes = {
    disabled: prop_types_1.default.bool,
    bsStyle: prop_types_1.default.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
    className: prop_types_1.default.string,
};
